export const ADD_FLOORS = 'ADD_FLOORS';
